<template>
	<footer class="footer">
		<div v-if="!hideAbout" class="footer__about">
			<ButtonGroup>
				<button @click="showAbout">
					<span
						><Icon name="info" /><span>About <em>ok</em>HiQ</span></span
					>
				</button>
			</ButtonGroup>
		</div>
		<div class="footer__content">
			<p>
				QUT acknowledges the Traditional Owners of the lands where QUT now
				stands.
			</p>
			<div class="footer__content__info">
				<p>CRICOS&nbsp;No. 00213J</p>
				<p>ABN 83&nbsp;791&nbsp;724&nbsp;622</p>
			</div>
		</div>
	</footer>
</template>

<script>
import ButtonGroup from '@/components/main/ButtonGroup'
import Icon from '@/components/main/Icon'

export default {
	name: 'hiq-footer',
	props: {
		hideAbout: Boolean
	},
	methods: {
		showAbout() {
			this.$store.commit('modals/show', 'about')
		}
	},
	components: {
		ButtonGroup,
		Icon
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.footer {
	&__about {
		background-color: $blue-73;
		overflow: hidden;

		button {
			@include button($blue-48, $white, $blue-48, $blue-98);
			> span {
				display: flex;
				align-items: center;
				> :not(:last-child) {
					margin-right: 0.5rem;
				}
				svg {
					@include square(2rem);
				}
			}
		}
	}

	&__content {
		padding: 1rem;
		color: $grey-32;
		text-align: center;
		font-size: 14px;

		p {
			margin: 0;
		}

		@include not-last {
			margin-bottom: 1rem;
		}

		&__info {
			@extend %flex-row;
			justify-content: center;

			@include not-last {
				$pad: 1.5rem;
				padding-right: $pad;
				margin-right: $pad;
				border-right: 1px solid $blue-73;
			}
		}
	}
}
</style>
